import { jsx, jsxs } from "react/jsx-runtime";
import { Box, IconButton, Stack } from "@mui/material";
import { ArrowDownward, ArrowUpward, Delete } from "../../../../icons/index.js";
import { useActions } from "./hooks/useActions.js";
function DynamicListItem(props) {
  const { value, index, errors, sorting, onDelete, onChange, itemsCount, RenderItem, onSwapItems, ...rest } = props;
  const { deleteItem, changeItem, moveUp, moveDown } = useActions(index, onDelete, onChange, onSwapItems);
  const canMoveUp = index > 0;
  const canMoveDown = index < itemsCount - 1;
  const isSortable = sorting === "on";
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "stretch", ...rest, children: [
    isSortable && /* @__PURE__ */ jsxs(Stack, { direction: "row", "data-testid": "dynamic-list-move-item-area", children: [
      /* @__PURE__ */ jsx(Box, { minWidth: 40, children: canMoveDown && /* @__PURE__ */ jsx(IconButton, { onClick: moveDown, "data-testid": "dynamic-list-move-item-down", children: /* @__PURE__ */ jsx(ArrowDownward, {}) }) }),
      /* @__PURE__ */ jsx(Box, { minWidth: 40, children: canMoveUp && /* @__PURE__ */ jsx(IconButton, { onClick: moveUp, "data-testid": "dynamic-list-move-item-up", children: /* @__PURE__ */ jsx(ArrowUpward, {}) }) })
    ] }),
    /* @__PURE__ */ jsx(Box, { "data-testid": "dynamic-list-item-input", marginX: 1, flexGrow: 1, children: /* @__PURE__ */ jsx(RenderItem, { value, onChange: changeItem, errors }) }),
    /* @__PURE__ */ jsx(Box, { "data-testid": "dynamic-list-item-command-area", children: /* @__PURE__ */ jsx(IconButton, { onClick: deleteItem, "data-testid": "dynamic-list-delete-item", children: /* @__PURE__ */ jsx(Delete, {}) }) })
  ] });
}
export {
  DynamicListItem
};
//# sourceMappingURL=DynamicListItem.js.map
